import { Component } from '@angular/core';

@Component({
  selector: 'app-result',
  template: '<router-outlet></router-outlet>',
  styleUrls: []
})
export class ResultComponent {}
